import { render, staticRenderFns } from "./pondEdit.vue?vue&type=template&id=210f0410&scoped=true"
import script from "./pondEdit.vue?vue&type=script&lang=js"
export * from "./pondEdit.vue?vue&type=script&lang=js"
import style0 from "./pondEdit.vue?vue&type=style&index=0&id=210f0410&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f0410",
  null
  
)

export default component.exports